import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Spinner } from '../components/Elements';
import { Layout } from '../components/Layout';
import { lazyImport } from '../utils/lazyImport';
import { SoPerfis } from '../features/auth/components/SoPerfis';

const { Dashboard } = lazyImport(() => import('../features/dashboard'), 'Dashboard');
const { Report } = lazyImport(() => import('../features/report'), 'Report');
const { ReportRem } = lazyImport(() => import('../features/report'), 'ReportRem');
const { Profile } = lazyImport(() => import('../features/user'), 'Profile');
const { Statistics } = lazyImport(() => import('../features/statistics'), 'Statistics');
const { Faq } = lazyImport(() => import('../features/faq'), 'Faq');
const { Support } = lazyImport(() => import('../features/support'), 'Support');

const { PrazosEntrega } = lazyImport(() => import('../features/fornecedores'), 'PrazosEntrega');
const { Compras } = lazyImport(() => import('../features/compras'), 'Compras');
const { PedidoCompra } = lazyImport(() => import('../features/compras'), 'PedidoCompra');
const { Acessos } = lazyImport(() => import('../features/acessos'), 'Acessos');

// O comprador não gera relatório: o que é do lojista o leva para as compras.
const DoLojista = ({ children }: { children: JSX.Element }) =>
  <SoPerfis perfis={['admin', 'lojista']} senao="/app/compras">{children}</SoPerfis>;

const { CoomingSoon } = lazyImport(() => import('../features/misc'), 'CoomingSoon');

// `mensagem` é opcional porque o mesmo spinner serve de fallback do Suspense, onde a espera é
// de milissegundos e não há o que explicar. Onde ela aparece é na página de relatório: buscar e
// montar a árvore de dezenas de milhares de linhas leva segundos, e essa era a parte da
// geração em que a tela não dizia nada.
export const Spin = ({ mensagem }: { mensagem?: string }) => (
  <div className="spinner-container">
    <Spinner />
    {mensagem && <span className="spinner-mensagem">{mensagem}</span>}
  </div>
)

const App = () => {
  return (
    <Layout>
      <Suspense fallback={<Spin />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

export const protectedRoutes = [
  {
    path: '/app/*',
    element: <App />,
    children: [
      { path: 'dashboard', element: <DoLojista><Dashboard /></DoLojista> },
      { path: 'profile', element: <Profile /> },
      { path: 'stats', element: <CoomingSoon /> }, // <Statistics />
      { path: 'faq', element: <Faq /> },
      { path: 'support', element: <Support /> },
      { path: 'report', element: <DoLojista><Report /></DoLojista> },
      { path: 'report-rem', element: <DoLojista><ReportRem /></DoLojista> },
      { path: 'prazos-entrega', element: <DoLojista><PrazosEntrega /></DoLojista> },
      { path: 'compras', element: <Compras /> },
      { path: 'compras/:id', element: <PedidoCompra /> },
      { path: 'acessos', element: <SoPerfis perfis={['admin']} senao="/app/compras"><Acessos /></SoPerfis> },
    ],
  },
];